module.exports = __webpack_public_path__ + "img/calendar-icon.3174edc8.png";